import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { renderPassage } from '../lib/annotate.js';
import { AnnotationRegion } from './AnnotationRegion.js';
/**
 * 阅读文章视图：练习页里唯一允许高亮与笔记的区域。
 * 答题区在 PracticePage 里是独立的列，既不挂本组件的事件，也没有任何锚点可写，
 * 加上服务端按 surface 校验锚点，因此「答题区禁止标注」在交互层与服务端两层同时成立。
 */
export function PassageView({ exam, annotations, containerRef, onCreate, onUpdate, onDelete, }) {
    const blocks = exam.passage.blocks;
    useEffect(() => {
        const container = containerRef.current;
        if (!container)
            return;
        renderPassage(container, blocks, annotations);
    }, [annotations, blocks, containerRef, exam.examId]);
    return (_jsxs("div", { className: "passage-wrap", "data-annotation-scope": "allowed", children: [_jsxs("div", { className: "passage-toolbar", children: [_jsx("span", { className: "faint", style: { fontSize: 12 }, children: "\u9009\u4E2D\u6587\u7AE0\u91CC\u7684\u6587\u5B57\u5373\u53EF\u9AD8\u4EAE\u6216\u5199\u7B14\u8BB0\uFF08\u7B54\u9898\u533A\u4E0D\u652F\u6301\u6807\u6CE8\uFF09" }), _jsx("span", { className: "practice-topbar__spacer" }), _jsxs("span", { className: "badge", children: [annotations.length, " \u6761\u6807\u6CE8"] })] }), exam.passage.introHtml ? (_jsx("div", { className: "passage-intro", dangerouslySetInnerHTML: { __html: exam.passage.introHtml } })) : null, _jsx(AnnotationRegion, { anchorKind: "passage", containerRef: containerRef, className: "passage", annotations: annotations, onCreate: onCreate, onUpdate: onUpdate, onDelete: onDelete })] }));
}
//# sourceMappingURL=PassageView.js.map